import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    gap: '0.5rem',
    flexWrap: 'wrap'
  }
}))

export default useStyles
